/*
File: assets/review-cards.js
Review Cards Section JavaScript
*/
document.addEventListener("DOMContentLoaded", function () {
  const track = document.getElementById("reviewCardsTrack");
  const prevBtn = document.getElementById("prevArrow");
  const nextBtn = document.getElementById("nextArrow");
  
  if (!track || !prevBtn || !nextBtn) return;
  
  let currentIndex = 0;
  const cards = track.children;
  const totalCards = cards.length;
  
  // Hide arrows if 4 or fewer cards
  if (totalCards <= 4) {
    prevBtn.style.display = "none";
    nextBtn.style.display = "none";
    return;
  }
  
  function updateArrows() {
    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex >= totalCards - 4;
  }
  
  function slideToIndex(index) {
    const cardWidth = cards[0].offsetWidth;
    const gap = 20;
    const offset = index * (cardWidth + gap);
    track.style.transform = `translateX(-${offset}px)`;
    currentIndex = index;
    updateArrows();
  }
  
  prevBtn.addEventListener("click", function () {
    if (currentIndex > 0) {
      slideToIndex(currentIndex - 1);
    }
  });
  
  nextBtn.addEventListener("click", function () {
    if (currentIndex < totalCards - 4) {
      slideToIndex(currentIndex + 1);
    }
  });
  
  updateArrows();
  
  window.addEventListener("resize", function () {
    if (window.innerWidth <= 768) {
      track.style.transform = "translateX(0)";
      currentIndex = 0;
    } else {
      slideToIndex(Math.min(currentIndex, totalCards - 4));
    }
  });
  
  // Enhanced scroll reveal for the entire section
  const revealSection = document.querySelector(".review-cards-section.scroll-reveal");
  if (revealSection) {
    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            revealSection.classList.add("revealed");
            observer.unobserve(entry.target); // reveal only once
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px" // Trigger slightly before element is fully visible
      }
    );
    revealObserver.observe(revealSection);
  }
  
  // Fallback for older browsers or if Intersection Observer fails
  function fallbackScrollReveal() {
    const section = document.querySelector(".review-cards-section.scroll-reveal");
    if (!section) return;
    
    function checkScroll() {
      const sectionTop = section.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      
      if (sectionTop < windowHeight - 100) {
        section.classList.add("revealed");
        window.removeEventListener("scroll", checkScroll);
      }
    }
    
    // Check if already in view
    checkScroll();
    
    // Listen for scroll events
    window.addEventListener("scroll", checkScroll, { passive: true });
  }
  
  // Use fallback if Intersection Observer is not supported
  if (!window.IntersectionObserver) {
    fallbackScrollReveal();
  }
});